export const VIEW_STORE_DETAILS = 'View Store details'
export const TODAYS_HOURS = 'Today\'s Hours:'
export const TOMORROW_HOURS = 'Tomorrow\'s Hours:'
export const CLOSED_TODAY = 'Closed Today'
export const CLOSED_TOMORROW = 'Closed Tomorrow'
export const CONTACT_STORE_MODAL_TITLE = 'Need it sooner? Call us.'
export const RIGHT_CONTENT_WRAPPER = 'right-content-wrapper'
